import { useEffect } from 'react'
import { useAppStore, isApplicationLocked } from '@/store/app'

export default function DisableClearOnSubmitted() {
	const { user } = useAppStore()

	useEffect(() => {
		const cls = 'lg-disable-hero-clear'
		// Disable clearing for any locked status (Submitted, Admitted, Not Accepted)
		if (isApplicationLocked(user?.application_process)) {
			document.documentElement.classList.add(cls)
		} else {
			document.documentElement.classList.remove(cls)
		}
		return () => {
			document.documentElement.classList.remove(cls)
		}
	}, [user?.application_process])

	return null
}
